import Image from "next/image";
import bgImg from "../../public/images/bg/bg-image-10.jpg";
import Link from "next/link";
import { DateTime } from 'luxon';

const EventBreadCrumb = ({ getMatchEvent }) => {

  const publishedDate = DateTime.fromISO(getMatchEvent.date.published)
    .setLocale('en-US')
    .toLocaleString(DateTime.DATE_FULL);


  return (
    <>
      <div className="breadcrumb-inner">
        <Image src={bgImg} alt="Education Images" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="content">
              <div className="content text-start">
                <ul className="page-list">
                  <li className="rbt-breadcrumb-item">
                    <Link href="/">Home</Link>
                  </li>
                  <li>
                    <div className="icon-right">
                      <i className="feather-chevron-right"></i>
                    </div>
                  </li>
                  <li className="rbt-breadcrumb-item active">
                    <Link href="/events">Events</Link>
                  </li>
                </ul>
                <h2 className="title mb--0">{(getMatchEvent)?.title}</h2>
                <br />
                <p className="description">{getMatchEvent.description.short}</p>

                <div className="rbt-author-meta mb--5">
                  {/* <div className="rbt-avater">
                    <Link href={`/profile/${getMatchCourse.id}`}>
                      {getMatchCourse.userImg && (
                        <Image
                          width={40}
                          height={40}
                          src={getMatchCourse.userImg}
                          alt={getMatchCourse.userName}
                        />
                      )}
                    </Link>
                  </div> */}
                  {/* <br/><br/> */}

                  <div className="breadcrumb-content-top text-left">
                    <ul className="meta-list justify-content-left">
                      <li className="list-item">
                        <i className="feather-clock"></i>
                        {/* <span>{matchedBlog.date.published}</span> */}
                        <span>{publishedDate}</span>
                      </li>
                      <li className="list-item">
                        <div className="rbt-author-info">
                          Prepared by CloudPedia.AI
                        </div>
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventBreadCrumb;
